<h1 mat-dialog-title class="dialog-header">{{ "mfa.setupTitle" | translate }}</h1>
<mat-divider style="margin: 1rem !important;"></mat-divider>
<mat-dialog-content class="mat-typography">
  <div class="flex justify-center pb-4">
    <div style="width: 22rem; max-width: 100%;">
      <app-mfa-enroll (done)="onDone()"></app-mfa-enroll>
    </div>
  </div>
</mat-dialog-content>
